import { render, staticRenderFns } from "./DirectMessageDialog.vue?vue&type=template&id=e6c193e4&scoped=true&"
import script from "./DirectMessageDialog.vue?vue&type=script&lang=js&"
export * from "./DirectMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./DirectMessageDialog.vue?vue&type=style&index=0&id=e6c193e4&scoped=true&lang=scss&"
import style1 from "./DirectMessageDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c193e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
